import _ from 'lodash';

import * as Elevated from '@pitaman71/omniglot-introspect';

import * as Objects from './Objects';
import * as Properties from './Properties';
import * as Relations from './Relations';

const __moduleName__ = 'omniglot-live-data.Patterns';

export class PropertyTerm<PatternSymbols extends string|number|symbol, TypeParams extends Properties.TypeParams> {
    mapping?: { [key in keyof TypeParams['Binding']]: PatternSymbols };
    exact?: TypeParams['Value']|undefined;
    contains?: TypeParams['Value'][]|undefined;

    private constructor() {  }
    
    // implement required methods from Serializable
    static ClassSpec = 'omiglot-live-data.Patterns.PropertyTerm';
    static Factory = Elevated.factories.concrete<PropertyTerm<any, any>>(PropertyTerm.ClassSpec, () => new PropertyTerm<any, any>());
    getFactory = () => PropertyTerm.Factory;
    getGlobalId(): number|string|null { return null; }
    marshal(visitor: Elevated.Visitor<this>): void {
        visitor.begin(this);
        visitor.primitive(this, 'mapping');
        visitor.primitive(this, 'exact');
        visitor.primitive(this, 'contains');
        visitor.end(this);
    }        
};

export class RelationTerm<PatternSymbols extends string|number|symbol, BindingType extends Objects.BindingType> {
    mapping?: { [key in keyof BindingType]: PatternSymbols };
    sense?: boolean;

    private constructor() {  }
    
    // implement required methods from Serializable
    static ClassSpec = 'omiglot-live-data.Patterns.RelationTerm';
    static Factory = Elevated.factories.concrete<RelationTerm<any, any>>(PropertyTerm.ClassSpec, () => new RelationTerm<any, any>());
    getFactory = () => RelationTerm.Factory;
    getGlobalId(): number|string|null { return null; }
    marshal(visitor: Elevated.Visitor<this>): void {
        visitor.begin(this);
        visitor.primitive(this, 'mapping');
        visitor.primitive(this, 'sense');
        visitor.end(this);
    }    

};

export class AnyTerm<PatternSymbols extends string|number|symbol> {
    property?: PropertyTerm<PatternSymbols, any>;
    relation?: RelationTerm<PatternSymbols, any>;
        
    private constructor() {  }
    
    // implement required methods from Serializable
    static ClassSpec = 'omiglot-live-data.Patterns.AnyTerm';
    static Factory = Elevated.factories.concrete<AnyTerm<any>>(AnyTerm.ClassSpec, () => new AnyTerm<any>());
    getFactory = () => AnyTerm.Factory;
    getGlobalId(): number|string|null { return null; }
    marshal(visitor: Elevated.Visitor<this>): void {
        visitor.begin(this);
        visitor.scalar(PropertyTerm.Factory, 'property');
        visitor.scalar(RelationTerm.Factory, 'relation' )
        visitor.end(this);
    }    
};

export class Proto<BindingType extends Objects.BindingType> {
    id: string;
    terms?: AnyTerm<keyof BindingType>[];
    
    private constructor() { 
        this.id = Elevated.factories.makeObjectId();
    }

    // implement required methods from Serializable
    static ClassSpec = 'omiglot-live-data.Patterns.Proto';
    static Factory = Elevated.factories.concrete<Proto<any>>(Proto.ClassSpec, () => new Proto<any>());
    getFactory = () => Proto.Factory;
    getGlobalId(): number|string|null { return this.id || null; }
    marshal(visitor: Elevated.Visitor<this>): void {
        visitor.begin(this);
        visitor.primitive(this, 'id');
        visitor.array(AnyTerm.Factory, 'terms');
        visitor.end(this);
    }
};
